export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';

export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_ERROR = 'INVITE_USER_ERROR';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';

export const COMPLETE_REGISTRATION_REQUEST = 'COMPLETE_REGISTRATION_REQUEST';
export const COMPLETE_REGISTRATION_SUCCESS = 'COMPLETE_REGISTRATION_SUCCESS';
export const COMPLETE_REGISTRATION_ERROR = 'COMPLETE_REGISTRATION_ERROR';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const ADD_USERFILE_REQUEST = 'ADD_USERFILE_REQUEST';
export const ADD_USERFILE_SUCCESS = 'ADD_USERFILE_SUCCESS';
export const ADD_USERFILE_ERROR = 'ADD_USERFILE_ERROR';
